export default {
    /** 共通 **/
//    setListObj (state, data) {
//        state.listObj = data
//    },
//    setListObjKeep (state) {
//        state.listObjKeep = Object.assign({},state.listObj) 
//        state.listObj = {}
//        state.listObjLoadStatus = 0
//    },
//    backListFromKeep (state) {
//        if (state.listObjKeep.data) {
//            state.listObj = Object.assign({},state.listObjKeep)
//        }
//    },
//    resetListObj (state) {
//        state.listObj = {}
//        state.listObjLoadStatus = 0
//    },
//    setListObjLoadStatus (state, status) {
//        state.listObjLoadStatus = status
//    },
//    setListObjAddSeeMore (state, resp ) {
//        let new_next_page = resp.data.next_page_url
//        let new_list = resp.data.data
//        let old_list = state.listObj.data.data
//        state.listObj.data.next_page_url = new_next_page
//        state.listObj.data.data = old_list.concat(new_list)
//    },
//    setListObjSeeMoreLoadStatus (state, status) {
//        state.listObjSeeMoreLoadStatus = status
//    },

    /** point **/
    setPoint (state, data) {
        state.point = data
    },
    setPointLoadStatus (state, status) {
        state.pointLoadStatus = status
    },

    /** 招待情報 **/
    setInviteInfo (state, inviteInfo) {
        state.inviteInfo = inviteInfo
    },
    setInviteInfoLoadStatus (state, status) {
        state.inviteInfoLoadStatus = status
    },
    resetInviteInfo (state) {
        state.inviteInfo = {}
        state.inviteInfoLoadStatus = 0
    },
    setCompanys (state, companys) {
        state.companys = companys
    },
    setCompanysLoadStatus (state, status) {
        state.companysLoadStatus = status
    },
    setDelCompanyStatus (state, status) {
        state.delCompanyStatus = status
    },
    setAddCompanyStatus (state, status) {
        state.addCompanyStatus = status
    },
    setCurrentCompany (state, company) {
        state.currentCompany = company.id + " " + company.group + " " + company.name
        try {
            sessionStorage.company = company.id + " " + company.group + " " + company.name
        } catch (e) {}
    },
    setShareInviteCodeStatus (state, status) {
        state.shareInviteCodeStatus = status
    },
    setCompanyDetail (state, detail) {
        state.companyDetail = detail
    },
    resetCompanyDetail (state) {
        state.companyDetail = {}
        state.companyDetailLoadStatus = 0
    },
    setCompanyDetailLoadStatus (state, status) {
        state.companyDetailLoadStatus = status
    },
    setCompanyInviteDetailChangeStatus (state, status) {
        state.companyInviteDetailChangeStatus = status
    },
    setCompanyInfo (state, resp) {
        let new_data = resp.data.company_info
        let old_data = state.companyDetail.data.company_info
        state.companyDetail.data.company_info = Object.assign({},old_data, new_data)
    },
    setCompanyOperat (state, operat) {
        if (operat == 'success') {
            state.companyOperat = 'show'
        } else {
            state.companyOperat = 'edit'
        }
    },
    resetCompanyOperat (state) {
        state.companyOperat = ""
    },
    setSaveCompanyInfoStatus (state, status) {
        state.saveCompanyInfoStatus = status
    },
    setTechLevel (state, techLevel) {
        state.techLevel = techLevel
    },
    setTechLevelLoadStatus (state, status) {
        state.techLevelLoadStatus = status
    },
    resetTechLevel (state) {
        state.techLevel = {}
        state.techLevelLoadStatus = 0
    },
    setTechChild (state, techChild) {
        state.techChild = techChild
    },
    setTechChildLoadStatus (state, status) {
        state.techChildLoadStatus = status
    },
    resetTechChild (state) {
        state.techChild = {}
        state.techChildLoadStatus = 0
    },
    /** 履歴書一覧 **/
    setTechResume (state, resp) {
        state.techResume = resp
    },
    setTechResumeLoadStatus (state, status) {
        state.techResumeLoadStatus = status
    },
    setTechResumeListSession (state) {
        try {
            // コンポネントのcreate()で前画面(一覧画面)のデータをSessionに保存してる、
            // 入力中に画面リフレッシュしたら、前画面(一覧画面)データがnullになり
            // 子画面再描画の際に、再びcreate()を実行し(この時点前画面のデータはnull)、nullで保存済みのsession情報を
            // 上書きの恐れがあるため、null判断必要
            if (state.techResume.data) {
                const list = JSON.stringify(state.techResume)
                sessionStorage.setItem('techResumeListSession',list)
            }
        } catch (e) {}
    },

    setTechResumeHasChangeForInputBarStatus (state, status) {
        state.techResumeHasChangeForInputBarStatus = status
    },

    /** 履歴書配信Flg更新 **/
    setChangeTechResumeMailFlg (state, resp) {
        state.changeTechResumeMailFlg = resp.data
    },
    setChangeTechResumeMailFlgStatus (state, status) {
        state.changeTechResumeMailFlgStatus = status
    },
    changeTechResumeSpecifyOutTime (state, data) {
        let idx = state.techResume.data.resume.findIndex((item)=>item.id == data.id)
        let obj = state.techResume.data.resume[idx]
        obj.recent_out_day = data.time
    },

    /** 受信日最新化  **/
    setUpdateTechResumeRecentInDay (state, resp) {
        state.updateTechResumeRecentInDay = resp.data
    },
    setUpdateTechResumeRecentInDayStatus (state, status) {
        state.updateTechResumeRecentInDayStatus = status
    },

    /** 履歴書削除  **/
    setDeleteTechResumeStatus (state, status) {
        state.deleteTechResumeStatus = status
    },

    deleteTechResumeFromList (state, id) {
        let idx = state.techResume.data.resume.findIndex((item)=>item.id == id)
        state.techResume.data.resume.splice(idx, 1)
    },

    // 履歴書一覧に新規追加・更新反映する
    updateTechResume (state, newObj) {
        if (!state.techResume.data) {
            try {
                if (sessionStorage.getItem('techResumeListSession')) {
                    state.techResume = JSON.parse(sessionStorage.getItem('techResumeListSession'))
                }
            } catch (e) {}
        }

        let idx = state.techResume.data.resume.findIndex((item)=>item.id == newObj.id)
        if (idx != -1) {
            let obj = state.techResume.data.resume[idx]
            state.techResume.data.resume.splice(idx, 1, newObj)
        } else {
            // 先頭に追加
            state.techResume.data.resume.unshift(newObj)
        }
    },

    /** 履歴書詳細 **/
    setResumeOperat (state, operat) {
        if (operat == 'success') {
            state.resumeOperat = 'show'
        } else {
            state.resumeOperat = operat == 'create_confirm' ? 'create' : 'edit'
        }
    },
    resetResumeOperat (state) {
        state.resumeOperat = ""
    },
    setSaveResumeInfoStatus (state, status) {
        state.saveResumeInfoStatus = status
    },
    setResumeInfo (state, resp) {
        state.resumeInfo = resp
    },
    setResumeInfoLoadStatus (state, status) {
        state.resumeInfoLoadStatus = status
    },

    setLatestPointInfo (state, data) {
        state.latestPointInfo = data
    },
    setLatestPointInfoLoadStatus (state, status) {
        state.latestPointInfoLoadStatus = status
    },
    setMakePointStatus (state, status) {
        state.makePointStatus = status
    },
    /** 個人画面 **/
    setPersonInfo (state, resp) {
        state.personInfo = resp
    },
    setPersonInfoLoadStatus (state, status) {
        state.personInfoLoadStatus = status
    },
    resetPersonInfo (state) {
        state.personInfo = {}
        state.personInfoLoadStatus = 0
    },
    setIdentityOkStatus (state, status) {
        state.identityOkStatus = status
    },
    setIdentityNgStatus (state, status) {
        state.identityNgStatus = status
    },

    /** 月明細　**/
    setPayStatusChangeItem (state, resp) {
        state.payStatusChangeItem = resp
    },
    setPayStatusChangeStatus (state, status) {
        state.payStatusChangeStatus = status
    },

    
}
